/**
 * @generated SignedSource<<6880fd4d158a24226beb491e2ce7832f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SalesAssociatePasswordModal_salesAssociate$data = {
  readonly id: string;
  readonly name: string | null;
  readonly avatar: {
    readonly url: string;
  } | null;
  readonly queueAppPassword: string | null;
  readonly " $fragmentType": "SalesAssociatePasswordModal_salesAssociate";
};
export type SalesAssociatePasswordModal_salesAssociate$key = {
  readonly " $data"?: SalesAssociatePasswordModal_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"SalesAssociatePasswordModal_salesAssociate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SalesAssociatePasswordModal_salesAssociate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "queueAppPassword",
      "storageKey": null
    }
  ],
  "type": "SalesAssociate",
  "abstractKey": null
};

(node as any).hash = "59893a2b71389392dfd3c4b1d4d09d9d";

export default node;
